import React from "react";
import "./index.css";
import HeaderVwLogo from "./media/logo_vwm.svg";

import SalesforceLogo from "./media/logo_ayuda_salesforce.svg";

class HeaderAyuda extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div
          className={
            "text-center mt-4 title_container text__center--" + this.props.marca
          }
        >
          {<img src={HeaderVwLogo} alt="VW Logo"></img>}
        </div>
        <div
          className={
            "title__container container-fluid h-100 title__container--" +
            this.props.marca
          }
        >
          <div className="contenido_header contenido__header--ayuda container">
            <div className="row">
              <div className="col-12 col-md-5 mt-3 h-100">
                <h1>
                  <span className="font-weight-light">Ayuda en línea</span>
                </h1>

                <h2 className="subtitle_header">
                  <span className="font-weight-bold">DWC-Salesforce</span>
                </h2>
              </div>

              <div className="col-md-7 d-none d-md-block pt-2 pb-2">
                <img src={SalesforceLogo} alt="Header" />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default HeaderAyuda;
